module.exports = __webpack_public_path__ + "static/model-tension-heuristics-preventing-accidental-design-debt-79de7b18f2b45582f67e30307131e9f3.png";